import { createSlice } from "@reduxjs/toolkit";
import { ssoLyricUrlAPI } from "../../services/ssoLyricUrl";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const ssoLyricUrlSlice = createSlice({
  name: "ssoLyricUrl",
  initialState: data,
  reducers: {
    ssoLyricUrlInfo(state) {
      state.isLoading = true;
    },
    ssoLyricUrlInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    ssoLyricUrlInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    ssoLyricUrlInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const ssoLyricUrlHandler = (data) => async (dispatch) => {
  try {
    dispatch(ssoLyricUrlAction.ssoLyricUrlInfo());
    const response = await ssoLyricUrlAPI(data);
    dispatch(ssoLyricUrlAction.ssoLyricUrlInfoSuccess(response));
  } catch (e) {
    dispatch(ssoLyricUrlAction.ssoLyricUrlInfoFailure(e));
  }
};
export default ssoLyricUrlSlice.reducer;
export const ssoLyricUrlAction = ssoLyricUrlSlice.actions;
